/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.no_genotype_cif_scd = void 0;
let no_genotype_cif_scd = [
    {
        idx: 1,
        day: 1,
        day_prev_evt: 0,
        hazard0_scd: 0.00090238400408900561,
        surv0_prev: 1,
        cif0_scd: 0.00090238400408900561,
        cumhaz0_scd: 0.00090238400408900561,
        cumhaz0_oth: 0,
    },
    {
        idx: 2,
        day: 2,
        day_prev_evt: 1,
        hazard0_scd: 0,
        surv0_prev: 0.99909761599591096,
        cif0_scd: 0.00090238400408900561,
        cumhaz0_scd: 0.00090238400408900561,
        cumhaz0_oth: 9.341033177538588e-6,
    },
    {
        idx: 3,
        day: 9,
        day_prev_evt: 2,
        hazard0_scd: 0.00092240543065620249,
        surv0_prev: 0.99908828339193234,
        cif0_scd: 0.0018239484623947069,
        cumhaz0_scd: 0.001824789434745208,
        cumhaz0_oth: 9.341033177538588e-6,
    },
    {
        idx: 4,
        day: 10,
        day_prev_evt: 9,
        hazard0_scd: 0.00093792217859084599,
        surv0_prev: 0.99816671893362663,
        cif0_scd: 0.002760151166013811,
        cumhaz0_scd: 0.002762711613336054,
        cumhaz0_oth: 9.341033177538588e-6,
    },
    {
        idx: 5,
        day: 18,
        day_prev_evt: 10,
        hazard0_scd: 0.00098092658379803077,
        surv0_prev: 0.99723051623000747,
        cif0_scd: 0.0037383610895584587,
        cumhaz0_scd: 0.0037436381971340848,
        cumhaz0_oth: 9.341033177538588e-6,
    },
    {
        idx: 6,
        day: 30,
        day_prev_evt: 18,
        hazard0_scd: 0.00099996846516481352,
        surv0_prev: 0.99625230630646289,
        cif0_scd: 0.0047345819792126379,
        cumhaz0_scd: 0.0047436066622988981,
        cumhaz0_oth: 9.341033177538588e-6,
    },
    {
        idx: 7,
        day: 36,
        day_prev_evt: 30,
        hazard0_scd: 0.0010060576739282965,
        surv0_prev: 0.99525608541680866,
        cif0_scd: 0.0057358670014700545,
        cumhaz0_scd: 0.0057496643362271943,
        cumhaz0_oth: 9.341033177538588e-6,
    },
    {
        idx: 8,
        day: 38,
        day_prev_evt: 36,
        hazard0_scd: 0.0010065815565374395,
        surv0_prev: 0.99425480039455127,
        cif0_scd: 0.0067366655460460237,
        cumhaz0_scd: 0.0067562458927646341,
        cumhaz0_oth: 9.341033177538588e-6,
    },
    {
        idx: 9,
        day: 43,
        day_prev_evt: 38,
        hazard0_scd: 0.0010196286705253424,
        surv0_prev: 0.99325400184997537,
        cif0_scd: 0.0077494158034462895,
        cumhaz0_scd: 0.0077758745632899766,
        cumhaz0_oth: 9.341033177538588e-6,
    },
    {
        idx: 10,
        day: 60,
        day_prev_evt: 43,
        hazard0_scd: 0.0010430462417174333,
        surv0_prev: 0.99224125159257515,
        cif0_scd: 0.008784369311796927,
        cumhaz0_scd: 0.0088189208050074106,
        cumhaz0_oth: 9.341033177538588e-6,
    },
    {
        idx: 11,
        day: 67,
        day_prev_evt: 60,
        hazard0_scd: 0.0010486206071063547,
        surv0_prev: 0.99120629808422445,
        cif0_scd: 0.0098237686618616489,
        cumhaz0_scd: 0.0098675414121137655,
        cumhaz0_oth: 9.341033177538588e-6,
    },
    {
        idx: 12,
        day: 105,
        day_prev_evt: 67,
        hazard0_scd: 0.0011958234396538636,
        surv0_prev: 0.99016689873415975,
        cif0_scd: 0.01100783344853733,
        cumhaz0_scd: 0.01106336485176763,
        cumhaz0_oth: 9.341033177538588e-6,
    },
    {
        idx: 13,
        day: 147,
        day_prev_evt: 105,
        hazard0_scd: 0,
        surv0_prev: 0.9889828339474841,
        cif0_scd: 0.01100783344853733,
        cumhaz0_scd: 0.01106336485176763,
        cumhaz0_oth: 2.0055142557807993e-5,
    },
    {
        idx: 14,
        day: 148,
        day_prev_evt: 147,
        hazard0_scd: 0,
        surv0_prev: 0.98897223787722599,
        cif0_scd: 0.01100783344853733,
        cumhaz0_scd: 0.01106336485176763,
        cumhaz0_oth: 3.0782825178681222e-5,
    },
    {
        idx: 15,
        day: 155,
        day_prev_evt: 148,
        hazard0_scd: 0,
        surv0_prev: 0.98896162849693714,
        cif0_scd: 0.01100783344853733,
        cumhaz0_scd: 0.01106336485176763,
        cumhaz0_oth: 4.1665279129259625e-5,
    },
    {
        idx: 16,
        day: 162,
        day_prev_evt: 155,
        hazard0_scd: 0,
        surv0_prev: 0.98895086616755623,
        cif0_scd: 0.01100783344853733,
        cumhaz0_scd: 0.01106336485176763,
        cumhaz0_oth: 5.2801435566229743e-5,
    },
    {
        idx: 17,
        day: 190,
        day_prev_evt: 162,
        hazard0_scd: 0.0012572204997870534,
        surv0_prev: 0.98893985305600207,
        cif0_scd: 0.012251148904855734,
        cumhaz0_scd: 0.012320585351554683,
        cumhaz0_oth: 5.2801435566229743e-5,
    },
    {
        idx: 18,
        day: 213,
        day_prev_evt: 190,
        hazard0_scd: 0.0012920533045831487,
        surv0_prev: 0.98769653759968368,
        cif0_scd: 0.013527305480186737,
        cumhaz0_scd: 0.013612638656137831,
        cumhaz0_oth: 5.2801435566229743e-5,
    },
    {
        idx: 19,
        day: 316,
        day_prev_evt: 213,
        hazard0_scd: 0.0013942778254217162,
        surv0_prev: 0.9864203810243527,
        cif0_scd: 0.014902649543993033,
        cumhaz0_scd: 0.015006916481559548,
        cumhaz0_oth: 5.2801435566229743e-5,
    },
    {
        idx: 20,
        day: 319,
        day_prev_evt: 316,
        hazard0_scd: 0.0013981427601633925,
        surv0_prev: 0.98504503696054635,
        cif0_scd: 0.016279883130854302,
        cumhaz0_scd: 0.01640505924172294,
        cumhaz0_oth: 5.2801435566229743e-5,
    },
    {
        idx: 21,
        day: 370,
        day_prev_evt: 319,
        hazard0_scd: 0.0014395251912546602,
        surv0_prev: 0.9836678033736852,
        cif0_scd: 0.01769589771363686,
        cumhaz0_scd: 0.017844584432977602,
        cumhaz0_oth: 5.2801435566229743e-5,
    },
    {
        idx: 22,
        day: 372,
        day_prev_evt: 370,
        hazard0_scd: 0,
        surv0_prev: 0.98225178879090258,
        cif0_scd: 0.01769589771363686,
        cumhaz0_scd: 0.017844584432977602,
        cumhaz0_oth: 6.5690202969835644e-5,
    },
    {
        idx: 23,
        day: 406,
        day_prev_evt: 372,
        hazard0_scd: 0.0014678377485702527,
        surv0_prev: 0.98223912877606512,
        cif0_scd: 0.019137665384977125,
        cumhaz0_scd: 0.019312422181547856,
        cumhaz0_oth: 6.5690202969835644e-5,
    },
    {
        idx: 24,
        day: 422,
        day_prev_evt: 406,
        hazard0_scd: 0.001478693187654038,
        surv0_prev: 0.98079736110472482,
        cif0_scd: 0.02058796376131174,
        cumhaz0_scd: 0.020791115369201894,
        cumhaz0_oth: 6.5690202969835644e-5,
    },
    {
        idx: 25,
        day: 447,
        day_prev_evt: 422,
        hazard0_scd: 0,
        surv0_prev: 0.97934706272839023,
        cif0_scd: 0.02058796376131174,
        cumhaz0_scd: 0.020791115369201894,
        cumhaz0_oth: 8.0064893329423521e-5,
    },
    {
        idx: 26,
        day: 471,
        day_prev_evt: 447,
        hazard0_scd: 0,
        surv0_prev: 0.9793329849176089,
        cif0_scd: 0.02058796376131174,
        cumhaz0_scd: 0.020791115369201894,
        cumhaz0_oth: 9.4978832789226344e-5,
    },
    {
        idx: 27,
        day: 503,
        day_prev_evt: 471,
        hazard0_scd: 0.0015187911761224103,
        surv0_prev: 0.97931837920476084,
        cif0_scd: 0.022075343874262431,
        cumhaz0_scd: 0.022309906545324304,
        cumhaz0_oth: 9.4978832789226344e-5,
    },
    {
        idx: 28,
        day: 517,
        day_prev_evt: 503,
        hazard0_scd: 0.0015361083858285163,
        surv0_prev: 0.97783099909181015,
        cif0_scd: 0.023577398271890437,
        cumhaz0_scd: 0.02384601493115282,
        cumhaz0_oth: 9.4978832789226344e-5,
    },
    {
        idx: 29,
        day: 536,
        day_prev_evt: 517,
        hazard0_scd: 0,
        surv0_prev: 0.97632894469418208,
        cif0_scd: 0.023577398271890437,
        cumhaz0_scd: 0.02384601493115282,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 30,
        day: 560,
        day_prev_evt: 536,
        hazard0_scd: 0.001610346291560554,
        surv0_prev: 0.97631393227302921,
        cif0_scd: 0.02514960179212521,
        cumhaz0_scd: 0.025456361222713376,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 31,
        day: 597,
        day_prev_evt: 560,
        hazard0_scd: 0.0017208295661744542,
        surv0_prev: 0.97474172875279441,
        cif0_scd: 0.026826966178347018,
        cumhaz0_scd: 0.02717719078888783,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 32,
        day: 606,
        day_prev_evt: 597,
        hazard0_scd: 0.0017248567941370461,
        surv0_prev: 0.97306436436657262,
        cif0_scd: 0.028505362858357346,
        cumhaz0_scd: 0.028902047583024875,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 33,
        day: 655,
        day_prev_evt: 606,
        hazard0_scd: 0.0017664959232422648,
        surv0_prev: 0.97138596768656227,
        cif0_scd: 0.030221312210170402,
        cumhaz0_scd: 0.030668543506267139,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 34,
        day: 666,
        day_prev_evt: 655,
        hazard0_scd: 0.0018035471486557613,
        surv0_prev: 0.9696700183347492,
        cif0_scd: 0.031970157806875017,
        cumhaz0_scd: 0.032472090654922903,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 35,
        day: 674,
        day_prev_evt: 666,
        hazard0_scd: 0.0018110588664977134,
        surv0_prev: 0.96792117273804468,
        cif0_scd: 0.033723120028833119,
        cumhaz0_scd: 0.034283149521420614,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 36,
        day: 804,
        day_prev_evt: 674,
        hazard0_scd: 0.0019724166880940954,
        surv0_prev: 0.96616821051608659,
        cif0_scd: 0.035628806330761056,
        cumhaz0_scd: 0.036255566209514707,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 37,
        day: 819,
        day_prev_evt: 804,
        hazard0_scd: 0.0020185181749401222,
        surv0_prev: 0.96426252421415859,
        cif0_scd: 0.037575187761300977,
        cumhaz0_scd: 0.038274084384454829,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 38,
        day: 876,
        day_prev_evt: 819,
        hazard0_scd: 0.0041662302341108435,
        surv0_prev: 0.96231614278361866,
        cif0_scd: 0.041584418370139015,
        cumhaz0_scd: 0.042440314618565671,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 39,
        day: 950,
        day_prev_evt: 876,
        hazard0_scd: 0.0021320849763656752,
        surv0_prev: 0.95830691217478059,
        cif0_scd: 0.043627610140334248,
        cumhaz0_scd: 0.044572399594931346,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 40,
        day: 982,
        day_prev_evt: 950,
        hazard0_scd: 0.0021488102854200085,
        surv0_prev: 0.9562637204045854,
        cif0_scd: 0.045682439458313621,
        cumhaz0_scd: 0.046721209880351354,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 41,
        day: 990,
        day_prev_evt: 982,
        hazard0_scd: 0.0021560276274581757,
        surv0_prev: 0.954208891086606,
        cif0_scd: 0.047739740189862573,
        cumhaz0_scd: 0.048877237507809528,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 42,
        day: 1102,
        day_prev_evt: 990,
        hazard0_scd: 0.0023683659082828134,
        surv0_prev: 0.95215159035505703,
        cif0_scd: 0.049994783555976752,
        cumhaz0_scd: 0.051245603416092342,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 43,
        day: 1123,
        day_prev_evt: 1102,
        hazard0_scd: 0.0023800782420519131,
        surv0_prev: 0.94989654698894288,
        cif0_scd: 0.052255611659665378,
        cumhaz0_scd: 0.053625681658144256,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 44,
        day: 1243,
        day_prev_evt: 1123,
        hazard0_scd: 0.0025260454905649864,
        surv0_prev: 0.94763571888525433,
        cif0_scd: 0.054649382594053789,
        cumhaz0_scd: 0.056151727148709245,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 45,
        day: 1439,
        day_prev_evt: 1243,
        hazard0_scd: 0.0028678702524820468,
        surv0_prev: 0.94524194795086591,
        cif0_scd: 0.057360213857980256,
        cumhaz0_scd: 0.059019597401191289,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 46,
        day: 1630,
        day_prev_evt: 1439,
        hazard0_scd: 0.0030958639680622839,
        surv0_prev: 0.94253111668693945,
        cif0_scd: 0.060278161980908865,
        cumhaz0_scd: 0.062115461369253569,
        cumhaz0_oth: 0.00011035522947862124,
    },
    {
        idx: 47,
        day: 1806,
        day_prev_evt: 1630,
        hazard0_scd: 0.0035862802624046473,
        surv0_prev: 0.93961316856401078,
        cif0_scd: 0.063647878141625466,
        cumhaz0_scd: 0.06570174163165822,
        cumhaz0_oth: 0.00011035522947862124,
    },
];
exports.no_genotype_cif_scd = no_genotype_cif_scd;



// WEBPACK FOOTER //
// ./demo/pages/components/primacy-cal-js/no_genotype_baseline_hazard.js